export enum WorkTypes {
  REMOTE,
  ON_SITE
}
